<template>
  <div class="container" style="text-align:center;">
    <div>
      <img src="./1.jpg" class="image">
    </div>
    <div style="font-size: 30px;margin-top: 10px;">富士苹果</div>
    <div class="message">
      <div class="item">编号：{{id}}</div>
      <div class="item">已扫描6次</div>
      <div class="item">最后一次扫描：2018-06-13 14:22</div>
    </div>
    <!-- <el-steps class="steps_1" :active="1" simple>
      <el-step title="已发货"><i slot="icon" class="fas fa-cart-plus fa-2x"></i></el-step>
      <el-step title="运输中"><i slot="icon" class="fas fa-car fa-2x"></i></el-step>
      <el-step title="已入库"><i slot="icon" class="fas fa-warehouse fa-2x"></i></el-step>
    </el-steps> -->
    <div class="steps_2">
      <el-steps direction="vertical" :active="6" space="1">
        <el-step title="生产" description="时间：2018-09-01"></el-step>
        <el-step title="出库" description="时间：2018-09-01"></el-step>
        <el-step title="运输至 陕西" description="时间：2018-09-01"></el-step>
        <el-step title="运输至 北京" description="时间：2018-09-01"></el-step>
        <el-step title="运输至 北京市海淀区" description="时间：2018-09-01"></el-step>
        <el-step title="运输至 北京市海淀区 学院路" description="时间：2018-09-01"></el-step>
        <el-step title="运输至 北京市海淀区 学院路 北京航空航天大学" description="时间：2018-09-01"></el-step>
        <el-step title="入库" description="时间：2018-09-01"></el-step>
      </el-steps>
    </div>
    <div class="scan">
      <div class="scan_title">扫描记录(时间 地点 设备)</div>
      <div class="scan_item">2018-09-12 12:22 山东济宁 GX123</div>
      <div class="scan_item">2018-09-12 12:22 内蒙古赤峰市 ZZ121</div>
      <div class="scan_item">2018-09-12 12:22 山东济宁 FC1232</div>
      <div class="scan_item">2018-09-12 12:22 山东济宁 FA121</div>
      <div class="scan_item">2018-09-12 12:22 山东济宁 CC121</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      id: ''
    }
  },
  mounted () {
    let that = this
    that.id = that.$route.params.id
  },
  created () {
    document.head.querySelector('meta[name=viewport]').content = 'width=device-width, initial-scale=1, maximum-scale=1'
  }
}
</script>

<style scoped>
.steps_1 {
  margin-top: 30px;
  background: #fe816d;
}
.steps_2 {
  margin-top: 40px;
  /* width: 400px;
  margin-left: auto; */
}
.message {
  margin-top: 10px;
  font-size: 15px;
}
.image {
  width: 300px;
  margin-top: 10px;
}
.scan {
  margin-top: 20px;
  font-size: 15px;
  text-align: left;
}
</style>
